/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AutomationTemplateQueryEngineTypes extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AutomationTemplateQueryEngineTypes");
    }

    getFixupPrototypeFunction() { return AutomationTemplateQueryEngineTypes.fixupPrototype; }

    static newInstance(model: Partial<AutomationTemplateQueryEngineTypes>): AutomationTemplateQueryEngineTypes {
        let obj = Object.assign(new AutomationTemplateQueryEngineTypes(), model);
        AutomationTemplateQueryEngineTypes.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AutomationTemplateQueryEngineTypes>): AutomationTemplateQueryEngineTypes {
        if (!model) return null;
        return AutomationTemplateQueryEngineTypes.newInstance(<AutomationTemplateQueryEngineTypes> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AutomationTemplateQueryEngineTypes) {
        if (!obj) return;

        models.AutomationTemplateQueryEngineTypes.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AutomationTemplateQueryEngineTypes): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AutomationTemplateQueryEngineTypes.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Template engine types to include
     */
    engine_types: Array<models.TemplateEngineType>;

}
